<template>
  <div id="newsdetail" class="clearfix">
    <div class="detail_top">
      <div class="inner detail_in clearfix">
        <img
          :src="site_logo"
          class="logo"
          alt=""
          @click="intoIndex()"
        />
        <div class="search clearfix">
          <input
            type="text"
            class=""
            v-model="keywords"
            placeholder="请输入要搜索的内容"
          />
          <a
            href="javascript:;"
            class="search_btn"
            @click="intoSearch"
            >搜索</a
          >
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="center">
        <!-- 普通帖子  special!=4-->
        <div class="thread" v-if="thread.special != 4">
          <h3 class="big_title">{{ thread.subject ? thread.subject : "" }}</h3>
          <div class="tags">
            <!-- 默认头像和头像的区分 -->
            <div class="avator">
              <img
                :src="
                  thread.avatar
                    ? thread.avatar
                    : '../../assets/imgs/noavatar_big.gif'
                "
              />
            </div>
            <div class="info">
              <!-- 判断显示用户名或'邻友' -->
              <span class="author">{{
                thread.author ? thread.author : "邻友"
              }}</span
              ><br />
              <span class="tag" v-if="thread.dateline">{{
                (thread.dateline ? thread.dateline : "") | momentDate
              }}</span>
            </div>
            <!-- <div class="hotReward">
              <img src="../../assets/imgs/huo.gif" /><br />
              <span class="reward">热帖奖励</span>
              <div class="reward money">0.8元</div>
            </div> -->
          </div>
          <div class="lineHeight"></div>
        </div>
        <!-- 是二手 -->
        <div class="hand" v-if="thread.fid == '253'">
          <hand-detail :thread="thread"></hand-detail>
        </div>
        <!-- 活动帖 special ==4 时显示-->
        <div class="activitys" v-if="thread.special == 4">
          <activity-detail :thread="thread"></activity-detail>
        </div>
        <div class="news_content" v-html="thread.message">
          <!-- 是二手 -->
          <!-- <div class="handAddresss">
            地址详情地址
          </div> -->
        </div>
        <div class="supports" v-if="thread.special !=4">
          <div class="top">
            <a id="supportBtn">
              <div class="con" @click="intoDownlyq"><span class="dz"><img src="~@/assets/imgs/dz.png"></span>赞</div>
            </a>
          </div>
          <div class="bottom" v-if="thread.supports">
            <div class="list">
                <span class="hand"><img src="~@/assets/imgs/dz.png"></span>
                <span class="pernum num">{{thread.supports}}</span>
                  <a class="num" v-for="(item,index) in thread.supportUsers" :key="index" @click="intoPerson(item.openId)">{{item.name}}、</a>
            </div>
          </div>
        </div>
        <!-- 评论盒子 -->
        <div class="pl_box">
          <p class="pl_title">
            <!-- 判断没评论条数显示0 -->
            <img src="@/assets/imgs/msg.png" />共<span>{{
              thread.replies ? thread.replies : 0
            }}</span
            >条评论
          </p>
          <!-- 回主帖 -->
          <div class="threadPl clearfix">
            <div class="userInfo">
              <!-- 当前登录用户的头像 -->
              <div class="L_ava">
                <div v-if="areaUserinfo">
                  <img :src="areaUserinfo.avatar">
                </div>
                <div v-else>
                  <img src="@/assets/imgs/noavatar_big.gif">
                </div>
              </div>
              <!-- 回主帖评论 -->
              <div class="zComments">
                <div class="commentWrapper">
                  <!-- 已登录 -->
                  <div class="isLogin" v-if="areaUserinfo">
                    <el-form :model="ruleForm"  ref="ruleForm">
                      <el-form-item prop="plContent">
                        <el-input
                          v-model="ruleForm.plContent"
                          class="comment"
                          type="textarea"
                          :autosize="autosize"
                          placeholder="说点什么吧..."
                        ></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          class="commentAction"
                          @click="submitpl('ruleForm')"
                          >评论</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                  <!-- 未登录 -->
                  <div class="noLogin" v-else  @click="login">
                    请先<span class="red">登录</span>后发表评论
                  </div>
                </div>
              </div>
            </div>
            <!-- 层级评论 -->
            <div class="plComments">
              <!-- 评论列表 -->
              <comment-list :comments="list" :level="0" :thread="thread"></comment-list>
            </div>
          </div>
          <div style="padding: 20px; color: #999; text-align: center; background: #fff;">
                <!-- <div v-if="!listCompleted">正在加载更多内容</div>
                <div v-else>已加载全部</div> -->
                <div>{{status}}</div>
          </div>
          <!-- <div v-else style="padding: 20px; color: #999; text-align: center; background: #fff;">暂无数据
          </div> -->
          <!-- <p class="hot_pl">以上为热门评论，邻友圈App还有更多内容</p> -->
        </div>
        <!-- 相关推荐 -->
        <!-- <div class="recom_box">
                    <h3 class="recom_title">相关推荐</h3>
                    <ul class="recom_list">
                        <li class="clearfix">
                            <div class="left_img">
                                <img class="l_img" src="http://dev.linyouquan.net/uploads/recommend/2019/09/19/saACo6.jpeg" alt="">
                            </div>
                            <div class="hasOne">
                                <h3 class="title">为互利合作注入新动力 为互联互通开辟新空间</h3>
                                <div class="btm_txt">
                                    <span class="tag blue">时政</span>
                                    <img class="avatar" src="" alt="">
                                    <a  class="msg" href="javascript:;">央视新闻·25评论·14分钟</a>
                                    <i class="close"></i>
                                </div>
                            </div>
                        </li>
                        <li class="clearfix">
                            <div class="left_img">
                                <img class="l_img" src="http://dev.linyouquan.net/uploads/recommend/2019/09/19/saACo6.jpeg" alt="">
                            </div>
                            <div class="hasOne">
                                <h3 class="title">为互利合作注入新动力 为互联互通开辟新空间</h3>
                                <div class="btm_txt">
                                    <span class="tag blue">时政</span>
                                    <img class="avatar" src="" alt="">
                                    <a  class="msg" href="javascript:;">央视新闻·25评论·14分钟</a>
                                    <i class="close"></i>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div> -->
      </div>
      <div class="right_box">
        <!-- 24h热帖 -->
        <hot :hotlist="navsObj.hot_threads"></hot>
        <!-- 热门活动 -->
        <hot-active :activitys="navsObj.activitys"></hot-active>
      </div>
    </div>
    <!-- 举报弹窗 -->
    <div class="jb_mask" v-show="showMask">
      <div class="jb_box">
        <p>举报此人</p>
        <div class="radio_list">
          <!-- <label
            v-for="(item, i) in jbList"
            :for="item.id"
            :class="{ active: item.show === true }"
            @click="changeChioce(item)"
          >
            <input type="radio" id="item.id" name="forbid" />{{ item.name
            }}<br /> </label
          ><br /> -->
        </div>
        <textarea name="" id="jbDesc" cols="30" rows="10"></textarea>
        <div class="jbBtns clearfix">
          <a href="javscript:;" class="btn cancleBtn" @click="hideMask()"
            >取消</a
          >
          <a href="javscript:;" class="btn sureBtn" @click="hideMask()">确定</a>
        </div>
        <i class="closex" @click="hideMask()"></i>
      </div>
    </div>
    <!-- 点赞跳下载 -->
    <div class="descMask" v-show="intoDownloadLyq">
      <div class="maskBox">
                  <div class="code" id="qrcode" ref="qrcode">
                  </div>
                  <div class="descTxt">邻友圈App或微信扫一扫参与互动</div>
                    <div class="closeR" @click="closefoot"><img  src="@/assets/imgs/c2.png"></div>
                  </div>
      </div>
    </div>
</template>

<script>
import {getWebsiteInfo} from "@/assets/js/global";
  import {
    storageData
  } from "@/assets/js/storage";
import moment from "moment";
import Header from "../common/header";
import Hot from "../common/hot";
import HotActive from "../common/Hotactive";
import service from "@/api/service/service";
import HandDetail from "../handdetail/handdetail";
import ActivityDetail from "../activity/activity";
import CommentList from '../commentList/commentList'
import QRCode from 'qrcodejs2'

export default {
  components: {
    Header,
    Hot,
    HotActive,
    HandDetail,
    ActivityDetail,
    CommentList,
  },
  data() {
    return {
      thread: {},
      keywords: "",
      showMask: false,//举报弹窗
      jbList: [
        {
          name: "淫秽色情",
          show: false,
          id: "one",
        },
        {
          name: "营销广告",
          show: false,
          id: "two",
        },
        {
          name: "恶意攻击谩骂",
          show: false,
          id: "three",
        },
        {
          name: "我有话要说",
          show: false,
          id: "four",
        },
      ],
      ruleForm: {
        plContent: "", //回复主帖的内容
      },
      navsObj: JSON.parse(localStorage.getItem("navsObj")),
      autosize: { minRows: 3 },
      // areaUserinfo:JSON.parse(localStorage.getItem('areaUserinfo')),
      areaUserinfo:{},
      token:storageData.getToken(),
      // token:'bI8gig90tDzlu2Rp8TlI0XIDRlDPUrPi',
      list:[],
      //分页
      page: 1, //滚动加载
      loading: false, //滚动加载
      scrolling: false, //是否是滚动
      listCompleted: 1, //已经加载完成的判断
      status:'',
      intoDownloadLyq:false,
      site_logo:'',
      hasMore:0
    };
  },
  filters: {
    momentDate(date) {
      return moment(date * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created(){
    this.site_logo = getWebsiteInfo().logo
    // let hlink = window.location.href
    // if(this.$route.query.site_id) {
    //   this.site_id = this.$route.query.site_id
    // }else{
    //   if(hlink.indexOf('bjdongba.cn')>-1) {
    //     this.streetId = '110105039000'
    //     this.isdb = true
    //     this.site_id = 2
    //   }else if(hlink.indexOf('bjchaoyang.cn')>-1) {
    //     this.site_id = 3
    //   }else if(hlink.indexOf('jiuxianqiao.cn')>-1) {
    //     this.site_id = 4
    //   }else {
    //     this.site_id = 1
    //   }
    // }
    // console.log(getWebsiteInfo().logo)
    // this.site_logo=getWebsiteInfo().logo
    // document.title = getWebsiteInfo().site_title
  },
  computed:{
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff')
    this.getDetail();
    this.comments();
    window.addEventListener("scroll", () => {
          if (this.scrolling) return;
          let scrollTop = document.documentElement.scrollTop ||  window.pageYOffset || document.body.scrollTop
          let clientHeight = document.documentElement.clientHeight ? document.documentElement.clientHeight+2 : document.body.clientHeight+2
          let scrollHeight = document.documentElement.scrollHeight ? document.documentElement.scrollHeight : document.body.scrollHeight
          // console.log(scrollTop , clientHeight ,scrollHeight)
          if (
            scrollTop +
              clientHeight >=
              scrollHeight
          ) {
              this.scrolling = true;
              this.loadMore();
              // console.log('执行了加载更多的方法')
              let timer = setTimeout(() => {
                this.scrolling = false;
                clearTimeout(timer);
              }, 400);
            }
      },true);

    // console.log(this.navsObj);
    // console.log(this.token);
    this.areaUserinfo=storageData.getUserInfo() //缓存中的用户信息
    this.$nextTick(()=>{
      this.qrcode()
    })

  },
  methods: {
    intoPerson(openId){
      let routeUrl = this.$router.resolve({
          path:`/pcenter?openId=${openId}&sid=${this.navsObj.site.id}`
        })
        window.open(routeUrl.href, '_blank');
    },
    login(){
        this.$router.push(`/arealogin?redirect=${this.$route.fullPath}`)
    },
    intoDownlyq(){
          this.intoDownloadLyq = true
      },
      closefoot(){
          this.intoDownloadLyq = false
      },
      qrcode() {
        let tid = this.$route.params.tid
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 200,
          height: 200,
          text: `https:${this.commonIp}/v1/threads/`+tid,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
    submitpl(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if(!this.ruleForm.plContent){
            alert('请输入评论内容')
          }else{
            let tid= this.$route.params.tid
            service.post(`${this.commonIp}/v1/threads/reply`,{
              tid:tid,
              message:this.ruleForm.plContent
            }).then((res) => {
              if(res.data.code ==200){
                // console.log(res)
                let plTxt = res.data.data.message
                // console.log(this.list)
                this.list.unshift({
                    _id:res.data.data.pid,
                    message:plTxt,
										pid:res.data.data.pid,
										subComments:[],
                    supports:0,
										author:this.areaUserinfo.username,
										avatar:this.areaUserinfo.avatar,
										dateline:moment(new Date().getTime()).unix(),
                })
                this.ruleForm.plContent = ''
              }
            })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    intoSearch() {
      this.$router.push({
        path: `/search??curtab=1&keywords=${this.keywords}`,
      });
    },
    getDetail() {
      let tid = this.$route.params.tid
      // console.log(tid)
      service.get(`${this.commonIp}/t/${tid}`).then((res) => {
        if (res.data.code == 200) {
          // console.log(res)
          let thread = res.data.data.thread;
          this.thread = thread;
        }
      });
    },
    comments() {
      this.loading = true
      let tid = this.$route.params.tid
      // console.log(tid)
      service.get(`${this.commonIp}/r/${tid}?page=${this.page}`)
      .then((res) => {
        // console.log(res);
        if (res.data.code == 200) {

          let data = res.data.data;
          let {comments} = data;
          if(this.page ==1 && data.comments.length <5){
            this.status = ''
          }
          if(data.comments.length!=0){
            this.status='正在加载更多内容'
            this.list = [...this.list, ...comments];
          }else{
            if(this.page !=1) {
              this.scrolling = false;
              this.loading = false
              this.hasMore = 1
              this.status = '没有更多了'
            }else{
              this.scrolling = false;
              this.loading = false
              this.status = '没有更多了'
            }
          }

           // this.listCompleted === 0;    //需要判断什么时候是已经加载完成，或是跟之前有,hasMore的一个字段 0没数据了
          // console.log(this.list)
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
      // console.log(this.list)
    },
    loadMore(){
      //需判断加载完成后让它不要再请求接口
      if (this.loading || this.hasMore) return;
      this.page += 1
      this.comments()

    },
    intoIndex() {
      this.$router.push({
        path: "/",
        name: "index",
      });
    },
    intoDetail(tid) {
      let routeData = this.$router.resolve({
        path: `/newsdetail/${tid}`,
      });
      window.open(routeData.href, "_blank");
    },

    changeChioce(item) {
      this.jbList.forEach(function (item) {
        item.show = false;
      });
      item.show = !item.show;
    },
    hideMask() {
      this.showMask = false;
    },
    showThings() {
      this.showMask = true;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/index.less";

#newsdetail {

  //加载更多
  .loadingMore{
      padding: 20px;
      color: #999;
      text-align: center;
      // background: #fff;
      background: -webkit-gradient(linear, left top, right top, color-stop(0, #4d4d4d), color-stop(.4, #4d4d4d), color-stop(.5, white), color-stop(.6, #4d4d4d), color-stop(1, #4d4d4d));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-animation: animate 1.5s infinite;

    }
    @-webkit-keyframes animate {
      /* 背景从-100px的水平位置，移动到+100px的水平位置。如果要移动Y轴的，设置第二个数值 */
      from {background-position: -100px;}
      to {background-position: 100px;}
    }
    @keyframes animate {
      from {background-position: -100px;}
      to {background-position: 100px;}
    }
    @-webkit-keyframes circle {
      0% {transform:rotate(-360deg);}
      100% {transform:rotate(0deg);}
    }
    @keyframes circle {
      0% {transform:rotate(-360deg);}
      100% {transform:rotate(0deg);}
    }
  // 举报弹层
  .jb_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;

    .jb_box {
      width: 640px;
      height: 400px;
      background: #fff;
      margin: 0 auto;
      top: 50%;
      left: 50%;
      position: fixed;
      margin-top: -200px;
      border-radius: 8px;
      padding: 20px;
      margin-left: -320px;

      p {
        margin: 0 0 16px 0;
      }

      .radio_list {
        padding-left: 20px;
        line-height: 34px;

        label {
          background: url("~@/assets/imgs/o.png") no-repeat left center;
          background-size: 20px;
          padding-left: 21px;

          &.active {
            background-image: url("~@/assets/imgs/xz.png");
          }
        }

        input {
          opacity: 0;
        }
      }

      #jbDesc {
        width: 100%;
        height: 66px;
        padding: 9px;
        outline: none;
        border: 1px solid #ededed;
      }

      .jbBtns {
        margin: 35px 0 0 0;

        .btn {
          width: 52px;
          height: 30px;
          line-height: 27px;
          display: inline-block;
          border-radius: 5px;
          border: 1px solid #dbe1e9;
          text-align: center;
          color: @fc32;
          font-size: @ft14;
          .fr();

          &.sureBtn {
            color: #fff;
            background: @red;
            border: 0;
            margin: 0 15px 0 0;
          }
        }
      }

      .closex {
        width: 12px;
        height: 12px;
        display: inline-block;
        padding: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        background: url("~@/assets/imgs/close1.png") no-repeat;
      }
    }
  }
  //下载邻友圈弹窗
  .descMask{
			position: fixed;
			top:0;
			left:0;
			width:100%;
			height: 100%;
			background: rgba(0,0,0,.7);
			z-index: 9999;
			.maskBox{
				width:40%;
				padding:45px 35px;
				box-sizing: border-box;
				background:#fff;
				border-radius:5px;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -40%);
				.close{
                    cursor: pointer;
					position: absolute;
					bottom:-36px;
					left:50%;
					width:20px;
					height: 20px;
					margin-left:-26px;
				}
				.txt{
					text-align: center;
					margin:0 0 20px 0;
				}
				.desc{
					font-size:15px;
					margin:0 0 10px 0;
					padding:0 0 0 30px;
					// background:url("~@/assets/imgs/ts.png") no-repeat left center;
					background-size:10px 10px;
				}
                .wImg{
                    width: 200px;
                    margin: 20px 0;
                    text-align: center;
                    margin: 0 auto;
                    img{
                        display: block;
                        width: 200px;
                        height: 200px;

                    }
                }
                .title{
                    margin:0 0 20px 0;
                    text-align: center;
                }
                .iknow{
                    color: #55aa7f;
                    cursor: pointer;
                    text-align: center;
                }
                .code{
                    width: 200px;
                    margin: 0 auto;
                    margin-bottom: 30px;
                    img{
                        width: 200px;
                        height: 200px;
                        display: block;
                    }
                }
                .descTxt{
                    margin: 10p 0;
                    font-size: 18px;
                    text-align: center;
                }
                .closeR{
                    position: absolute;
                    right: 15px;
                    top: 15px;
                    img{
                        display: block;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
			}
		}
  .detail_top {
    position: relative;
    width: 100%;
    border-bottom: 1px solid #ededed;

    .detail_in {
      line-height: 40px;
      padding: 15px 0;
    }

    .logo {
      width: 150px;
      margin: 5px 0 0 0;
      cursor: pointer;
      .fl();
    }

    .navlist {
      .fl();
      margin: 0 0 0 20px;

      a {
        color: #323232;
        font-size: @ft22;

        &.cur {
          color: #b5b5b5;
        }
      }
    }

    .search {
      .fr();
      height: 40px;
      line-height: 40px;
      border: 1px solid #ededed;
      width: 320px;
      border-radius: 5px;

      input {
        height: 100%;
        border: 0;
        width: 80%;
        background: #f4f5f6;
        float: left;
        padding: 0 0 0 8px;
      }

      .search_btn {
        width: 20%;
        height: 100%;
        text-align: center;
        display: inline-block;
        color: #fff;
        font-size: @ft20;
        border-radius: 0 5px 5px 0;
        background: #208bdc;
      }
    }
  }

  .center {
    width: 752px;
    .fl();
    // 回主帖
    .threadPl {
      margin: 20px 0 0;
      padding: 0 0 20px 0;
      display: inline-block;
      width: 100%;
      .userInfo {
        overflow: hidden;
        margin-bottom: 20px;
        // 主帖头像
        .L_ava {
          width: 40px;
          height: 40px;
          margin: 0 10px 0 0;
          float: left;
          .fl();
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
          }
        }
        // 回主帖评论框
        .zComments {
          width: 702px;
          float: left;
          .commentWrapper {
            .isLogin {
              width: 100%;
              background-color: #f2f2f2;
              border-radius: 5px;
              padding: 16px;
              box-sizing: border-box;
              position: relative;
              overflow: auto;
              cursor: pointer;
              .commentAction {
                margin-top: 10px;
                float: right;
                background-color: #505050;
                border-radius: 4px;
                width: 66px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                font-size: 14px;
                opacity: 0.3;
                &:hover {
                  opacity: 0.2;
                }
              }
              .comment {
                width: 99%;
                // max-height: 102px;
                // height: 102px;
                line-height: 24px;
                resize: none;
                clip: rect();
                background: none;
                border: 1px solid #f2f2f2;
                outline: none;
                font-size: 16px;
              }
              .expand {
                transition: height 0.5s ease-in-out;
                -webkit-transition: height 0.5s ease-in-out;
                -moz-transition: height 0.5s ease-in-out;
              }
            }
            .noLogin {
              height: 146px;
              line-height: 146px;
              text-align: center;
              width: 100%;
              background-color: #f2f2f2;
              border-radius: 5px;
              box-sizing: border-box;
              .red {
                color: red;
                padding: 0 5px;
                cursor: pointer;
              }
            }
          }
        }
      }

    }

    //帖子
    .thread {
      .big_title {
        font-size: @ft24;
        margin: 20px 0 0 0;
        color: #323232;
        font-weight: 700;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .tags {
        width: 100%;
        display: inline-flex;
        margin: 8px 0;

        .avator {
          margin-top: 10px;
          width: 48px;

          img {
            object-fit: cover;
            width: 48px;
            height: 48px;
            border-radius: 50%;
          }
        }

        .info {
          margin-top: 10px;
          padding-left: 10px;
          box-sizing: border-box;
          flex: 1;

          .author {
            font-size: 16px;
          }
        }

        .hotReward {
          width: 100px;
          text-align: right;

          img {
            width: 28px;
            height: 28px;
          }

          .reward {
            font-size: 12px;
          }
        }

        .tag {
          color: #5c5c5c;
          font-size: 11px;
          margin: 0 2px 0 0;
        }
      }
      .lineHeight {
        height: 1px;
        width: 100%;
        background: #f2f2f2;
      }
    }

    .news_content {
      margin-top: 10px;
      max-width: 752px;
      width: 752px;
      line-height: 26px;
      overflow: hidden;
      section{
          width: 752px!important;
          max-width: 100%!important;
           section{
                width: 100%!important;
                max-width: 100%!important;
                img {
                max-width: 100%!important;
                }
            }
      }
      img {
        width: 100%!important;
        max-width: 100%!important;
          &.att{
            max-width: 752px;
            overflow: hidden;
            object-fit: cover;
          }
          &.sm{
            max-width: 40px;
            margin: 0 5px 0 0;
            display: inline-block;
            object-fit: cover;
          }
          // height: auto;
      }

      .handAddresss {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #a4d3ff;
        color: #0084ff;
        padding: 0 5px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        margin: 20px 0;
      }
    }
    //点赞
    .supports{
      margin: 40px 0 10px 0;
      .top{
        width: 120px;
        margin: 0 auto;
        margin-bottom: 10px;
        #supportBtn{
          margin: 0 auto;
          cursor: pointer;
          display: block;
          height: 40px;
          line-height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
          border:1px solid #e8e8e8;
          .con{
            color: #999;
            text-align: center;
            .dz{
              display: inline-block;
              margin-right: 5px;
              margin-top: 5px;
              vertical-align: middle;
              img{
                width: 22px;
              }
            }
          }
        }
      }
      .bottom{
        margin:20px 0 10px 0;
        .list{
          .num{
            padding-right: 5px;
            color: #436cb1;
            cursor: pointer;
          }
          .hand{
            display: inline-block;
              margin-right: 5px;
              vertical-align: middle;
              img{
                width: 22px;
              }
          }
        }
      }
    }
    .advBanner {
      border: 1px solid #ededed;
      padding: 5px 30px;
      position: relative;

      .btn {
        right: 0;
        bottom: 0;
        position: absolute;
        color: #898989;
        font-size: 11px;
        text-align: center;
        width: 42px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        background: rgba(236, 236, 236, 0.9);
      }

      .banner {
        width: 100%;
        height: 78px;
        position: relative;

        .arrow {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -10px;
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 1px solid red;
        }

        .R_arr {
          left: auto;
          right: 0;
        }

        ul {
          li {
            overflow: hidden;
            text-align: center;

            img {
              width: auto;
              height: 78px;
              vertical-align: middle;
            }
          }
        }
      }
    }
    .pl_box {
      margin: 30px 0;
      .hot_pl {
        text-align: center;
        color: #436cb1;
        font-size: @ft14;
        margin: 0 0 20px 0;
      }

      .pl_title {
        height: 30px;
        line-height: 30px;
        font-size: @ft14;

        span {
          margin: 0;
          font-weight: bold;
          color: #fa5e59;
          font-size: @ft20;
        }

        img {
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
          width: 20px;
        }
      }
    }

    .recom_box {
      .recom_title {
        color: #323232;
        padding: 0 0 0 23px;
        background: url("~@/assets/imgs/line.png") no-repeat left center;
      }

      .recom_list {
        li {
          padding: 20px 0 15px 0;
          border-bottom: 1px solid #efefef;
        }

        .left_img {
          width: 135px;
          height: 90px;
          text-align: center;
          overflow: hidden;
          float: left;
          margin: 0 10px 0 0;

          img {
            height: 100%;
          }
        }

        .hasOne {
          float: left;
          padding: 0 10px 0 0;
          width: 530px;

          h3 {
            cursor: pointer;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #323232;
            line-height: 26px;
            font-weight: bold;
            font-size: 18px;
            max-height: 52px;
          }

          .btm_txt {
            font-size: 11px;
            height: 20px;
            margin: 10px 0 0 0;
            line-height: 20px;
            padding: 0 10px 0 0;
          }

          .tag {
            &.blue {
              color: #77adf8;
              border: 1px solid #ffaa6a;
              padding: 0 7px;
              display: inline-block;
              border-radius: 2px;
              border-color: #77adf8;
            }
          }

          .avatar {
            margin: 0 10px;
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: top;
            border-radius: 50%;
            border: 1px solid red;
          }

          .msg {
            color: #5c5c5c;
          }

          .close {
            width: 10px;
            height: 10px;
            margin-top: 10px;
            cursor: pointer;
            float: right;
            background: url("~@/assets/imgs/close1.png") no-repeat;
            background-size: 10px;
          }
        }
      }
    }
  }

  .right_box {
    width: 318px;
    margin: 0 0 0 16px;
    .fr();

    .ornot_login {
      margin: 20px 0;
      padding: 17px;
      background: @bg45;

      .login_inner {
        width: 100%;
        padding: 13px;
        font-size: @ft12;
        color: #5c5c5c;
        background: #fff;

        .user_top {
          display: flex;
          border-bottom: 1px solid #e8e8e8;

          .a_img {
            flex: 0 0 40px;
            width: 40px;
            margin: 0 10px 0 0;

            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
          }

          .user_r {
            flex: 1;
            padding: 0 0 10px 0;

            .name {
              font-size: @ft14;
              color: @fc32;
              font-weight: 700;
            }

            a {
              color: #fff;
              font-size: 11px;
              text-align: center;
              padding: 1px 12px;
              border-radius: 3px;
              background: @blues;
              position: relative;
              display: inline-block;
              margin: 0 0 3px 0;

              &::before {
                display: block;
                position: absolute;
                left: -10px;
                top: 5px;
                content: "";
                width: 0;
                height: 0;
                border-width: 5px;
                border-style: solid;
                border-color: transparent @blues transparent transparent;
              }
            }
          }
        }

        .user_list {
          li {
            background: url("~@/assets/imgs/dot.png") no-repeat left center;
            padding: 0 0 0 12px;
            margin: 10px 0;

            a {
              color: @fc32;
            }
          }
        }
      }

      .signout_box {
        .signout {
          display: inline-block;
          color: #5c5c5c;
          width: 100%;
          text-align: right;
        }

        .avat_box {
          .avat {
            text-align: center;

            img {
              width: 46px;
              height: 46px;
              border-radius: 50%;
            }
          }

          p {
            color: #323232;
            font-size: @ft12;
          }
        }
      }

      .gzBox {
        width: 90%;
        margin: 0 auto;

        .gzlist {
          float: left;
          width: 50%;
          font-size: @ft22;
          color: #323232;
          text-align: center;
          margin: 10px 0 0;

          &:first-child {
            border-right: 1px solid #efefef;
          }

          span {
            font-size: @ft12;
            display: block;
            color: #5c5c5c;
          }
        }
      }
    }

    .adv_box {
      padding: 20px 18px;
      background: @gray;

      .imgBox {
        border: 3px solid #ff4c45;
        overflow: hidden;
        width: 100%;
        height: 210px;
        text-align: center;
        position: relative;

        img {
          width: auto;
          vertical-align: middle;
          height: 100%;
        }

        .show {
          position: absolute;
          right: 0;
          bottom: 0;
          display: inline-block;
          font-size: 11px;
          width: 42px;
          height: 20px;
          line-height: 20px;
          color: #898989;
          text-align: center;
          background: rgba(236, 236, 236, 0.9);
        }
      }
    }

    .hotBox {
      background: @gray;
      padding: 10px 0px 8px;
      margin: 20px 0;

      .list_box {
        .list {
          cursor: pointer;
          height: 62px;
          padding: 0 0 10px 0;
          margin: 10px 0 0 0;
          border-bottom: 1px solid #e8e8e8;

          .left {
            margin: 0 10px 0 0;
            width: 52px;
            height: 52px;
            text-align: center;
            overflow: hidden;
            .fl();

            img {
              width: auto;
              height: 100%;
              vertical-align: middle;
            }
          }

          .right {
            .fl();
            color: #323232;
            width: 182px;
            font-size: @ft14;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
            margin: 6px 0 0 0;

            &:hover {
              color: #2d8ed9;
            }
          }

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }

  .noread {
    margin: 10px 0;
    line-height: 28px;
    height: 28px;
    text-align: center;
    color: #fff;
    padding: 0 10px 0 0;
    background: @lightblue;

    .close {
      display: inline-block;
      width: 20px;
      text-align: center;
      height: 15px;
      margin: 7px 0 0 0;
      .fr();
      background: url(~@/assets/imgs/close.png) no-repeat right center;
      background-size: 12px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
  .el-textarea__inner {
    border: none;
    background: none;
    padding: 0;
    resize: none;
  }
  .news_content {
      margin-top: 10px;
      max-width: 100%!important;
      width: 752px!important;
      line-height: 26px;
      section{
          // width: 752px!important;
          max-width: 100%!important;
           section{
                // width: 100%!important;
                max-width: 100%!important;
                img {
                max-width: 100%!important;
                }
            }
      }
      img {
        width: 100%!important;
        max-width: 100%!important;
          &.att{
            max-width: 752px;
            overflow: hidden;
            object-fit: cover;
          }
          &.sm{
            max-width: 40px!important;
            margin: 0 5px 0 0;
            display: inline-block;
            object-fit: cover;
          }
          // height: auto;
      }
      .handAddresss {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #a4d3ff;
        color: #0084ff;
        padding: 0 5px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        margin: 20px 0;
      }
    }
    .sm{
      display: inline-block;
      vertical-align: middle;
      margin: 0 2px;
      width: 40px;
      height: 40px;
    }
    .att{
      max-width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/detail/newsdetail.vue